module.exports = __webpack_public_path__ + "static/media/choco-piedras-1.c1dbcf20.png";